import _ from 'lodash';
import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { Typography } from '@mui/material';
import { palette } from '../../styles/theme';

export function WidgetTruncatedText ({ text, options = {}, styles, truncated }) {
    const textStyle = {
        color: styles?.color || palette.secondary[600],
        textDecoration: styles?.textDecoration || 'underline',
        fontWeight: styles?.fontWeight || 400,
    };
    return (
        <Tooltip title={text}>
            <Typography variant='widgetLink' style={ textStyle }>
                {!truncated ? _.truncate(text, _.defaultsDeep({}, options, _.defaultTruncateOptions)) : text}
            </Typography>
        </Tooltip>);
}

// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    WidgetTruncatedText.displayName = 'WidgetTruncatedText';
}
